import React, { Component } from 'react';
import { connect } from 'react-redux';
import MapListing from '../../components/map-listings';
import PageWrap from '../../components/page-wrap';
import PageMeta from '../../components/PageMeta';

class Content extends Component {
  render() {
    return (
      <PageWrap>
        <PageMeta
          title="Nearby Cigar Shops and Cigar Lounges"
          description="Discover nearby cigar shops and cigar lounges in your area with our user-friendly search tool. Find the perfect spot to relax, indulge, and enjoy a premium cigar experience. Start your search now!"
        >
          <MapListing />
        </PageMeta>
      </PageWrap>
    );
  }
}

export default connect(({ settings }) => ({ settings }))(Content);
